import React from "react";
import Redirect from "react-router-dom/es/Redirect";
import * as LoginActions from "../../../redux/action/login-action";
import { connect } from "react-redux";

class LogoutPage extends React.Component {
  componentDidMount() {
    this.props.doLogout();
  }

  render() {
    return (
      <div>
        {this.props.redirectToLogin ? <Redirect to={"/login"} /> : null}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    redirectToLogin: state.login.redirectToLogin
  };
}

function mapDispatchToProps(dispatch) {
  return {
    doLogout: () => dispatch(LoginActions.logout())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LogoutPage);
